var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":"true","max-width":"300px"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_c('v-icon',[_vm._v("mdi-alert")]),_vm._v(" Not found ")],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }